import { motion, useReducedMotion } from "framer-motion";
import { callClinic, whatsappClinic } from "@/components/CTAButtons";

export const Hero = () => {
  const reduceMotion = useReducedMotion();
  const rise = (delay) =>
    reduceMotion
      ? {}
      : {
          initial: { opacity: 0, y: 64 },
          animate: { opacity: 1, y: 0 },
          transition: { duration: 1.0, delay, ease: [0.16, 1, 0.3, 1] },
        };

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="bg-[#FDFCF8] pb-10 pt-20"
    >
      <div className="mx-auto w-full max-w-7xl px-3 sm:px-6 lg:px-10">
        <motion.div {...rise(0.2)}>
          <div className="relative">
        <img
          src="/hero-doctor.webp"
          alt="Smart Dental Clinic — Complete Dental Care for You & Your Family"
          data-testid="hero-doctor-image"
          fetchPriority="high"
          className="block h-auto w-full"
        />
        {/* Invisible tap area over the Call Clinic button baked into the approved artwork */}
        <button
          data-testid="hero-image-call-btn"
          onClick={callClinic}
          aria-label="Call Clinic"
          className="absolute cursor-pointer rounded-full bg-transparent"
          style={{ left: "6.5%", top: "53.3%", width: "50.5%", height: "6.5%" }}
        />
        {/* Invisible tap area over the WhatsApp Clinic button baked into the approved artwork */}
        <button
          data-testid="hero-image-whatsapp-btn"
          onClick={whatsappClinic}
          aria-label="WhatsApp Clinic"
          className="absolute cursor-pointer rounded-full bg-transparent"
          style={{ left: "6.5%", top: "60.4%", width: "50.5%", height: "5.4%" }}
        />
        {/* Invisible tap area over the hamburger icon baked into the approved artwork */}
        <button
          data-testid="hero-image-menu-btn"
          onClick={() => window.dispatchEvent(new Event("sdc:toggle-menu"))}
          aria-label="Open navigation menu"
          className="absolute cursor-pointer bg-transparent"
          style={{ left: "84.5%", top: "1.8%", width: "10.5%", height: "4.5%" }}
        />
          </div>
        </motion.div>
        <motion.div {...rise(0.55)}>
          <img
            src="/hero-chair.webp"
            alt="Modern Dentistry. Comfortable Care — Smart Dental Clinic, Bahadurpura, Hyderabad"
            data-testid="hero-chair-image"
            className="mt-3 block h-auto w-full"
          />
        </motion.div>
      </div>
    </section>
  );
};
